import type { AccessStatusResponse } from '@lunya/contracts'
import { API_PATHS } from '@lunya/contracts'

import { createQuery } from '~/shared/api'

import { ACCESS_STATUS_REFETCH_INTERVAL_MS } from '../config'
import { mapAccessStatusFromApi } from './mappers/mapAccessStatusFromApi'
import type { AccessStatus } from '../types'

/**
 * GET /access/status — гейт подписки на канал.
 *
 * Запрос фоновый, поэтому кэш `fresh` (устаревший ответ тут вреден: человек уже подписался,
 * а мы держим его на заглушке — значит, перезапрашиваем при каждом монтировании) и редкий
 * интервал перезапроса — минута. Чаще не нужно:
 * подписка меняется руками, и каждая проверка стоит вызова getChatMember на бэке.
 * Кнопка «Я подписалась» перезапрашивает мгновенно, не дожидаясь интервала.
 */
export const AccessStatusQuery = createQuery<void, AccessStatusResponse, AccessStatus>({
  key: 'access.status',
  path: API_PATHS.access.status,
  transform: mapAccessStatusFromApi,
  cacheBehavior: 'fresh',
  queryOptions: {
    refetchInterval: ACCESS_STATUS_REFETCH_INTERVAL_MS,
    // Возврат в аппу после подписки — самый частый сценарий снятия гейта, ради него
    // единственного нарушаем глобальное refetchOnWindowFocus: false.
    refetchOnWindowFocus: true,
    // Гейт не должен мигать при первой же сетевой ошибке: пока ответа нет, доступ открыт.
    retry: 2,
  },
})
